export default "__VITE_ASSET__CrdDzVEb__"